import apiClient from './apiClient';

export const getTranslations = (translationType, refId) => apiClient.get(`/language-translations?translationType=${translationType}&refId=${refId}`);
